export type NetworkId = 'instagram' | 'linkedin' | 'youtube' | 'telegram';

export type PublicNetworkLinks = Record<NetworkId, string | null>;

export type ContactId = 'email' | 'phone';

export type PublicContactInfo = Record<ContactId, string | null>;

export type PublicConfiguration = {
  network: PublicNetworkLinks;
  publicContacts: PublicContactInfo;
  isPublicOffer: boolean;
  cachedAt: string;
};

export const NETWORK_IDS: NetworkId[] = [
  'instagram',
  'linkedin',
  'youtube',
  'telegram',
];

export const emptyNetwork = (): PublicNetworkLinks => ({
  instagram: null,
  linkedin: null,
  youtube: null,
  telegram: null,
});

export const emptyContact = (): PublicContactInfo => ({
  email: null,
  phone: null,
});
